import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function list(page, query) {
  return request({
    url:    `/provider/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
};

function find(id) {
  return request({
    url:    `/provider/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
};

function save(values) {
  return request({
    url:    '/provider/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
};

function update(id, values) {
  return request({
    url:    `/provider/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
};

function remove(id) {
  return request({
    url:    `/provider/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
};

function filter(params) {
  return request({
    url:    '/provider/filter',
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params: params
  });
};

const ProviderService = {
  list, find, save, update, remove, filter
};

export default ProviderService;
